/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Account_AcInputs */

const en_pc_cmp_r_account_ac = /** @type {(inputs: Pc_Cmp_R_Account_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adobe account for paid plans and cloud features`)
};

const zh_pc_cmp_r_account_ac = /** @type {(inputs: Pc_Cmp_R_Account_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费版和云功能需要 Adobe 账号`)
};

/**
* | output |
* | --- |
* | "Adobe account for paid plans and cloud features" |
*
* @param {Pc_Cmp_R_Account_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_account_ac = /** @type {((inputs?: Pc_Cmp_R_Account_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Account_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_account_ac(inputs)
	return zh_pc_cmp_r_account_ac(inputs)
});
export { pc_cmp_r_account_ac as "pc.cmp.r.account.ac" }